@if ({ showError: control.invalid && (control.dirty || control.touched)}; as vm) {
  @if (vm.showError) {
    @if (classType === 'docInput') {
      <div style="text-align: right;">
        <span>
          <label class="error" role="alert" aria-live="polite">
            <small>{{ message | translate }}</small>
          </label>
        </span>
      </div>
      <div class="clearfix"></div>
    }
    @if (classType === 'bootstrap') {
      <div class="invalid-feedback">
        <span>{{ message | translate }}</span>
      </div>
    }
  }
}
